import { Injectable } from '@angular/core';
import { DataroomNode } from '@core/models/dataroom-node.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface DataroomState extends EntityState<DataroomNode> {
  nodes: DataroomNode[];
}

export function createInitialState(): DataroomState {
  return { nodes: null };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'dataroom', resettable: true })
export class DataroomStore extends EntityStore<DataroomState, DataroomNode> {
  constructor() {
    super(createInitialState());
  }
}
